/* global Stripe */

import './style.less';
import { keyBy } from 'lodash';

export default function(
  $log,
  $state,
  $uibModalInstance,
  $scope,
  UserClass,
  ApiClass,
  event,
  bundle,
  adminRegistration,
  profileData,
  manage,
  loadContent,
  Swal
) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  let stripe;
  let elements;
  let listPriceCents;
  let card;

  const userRegBasePayload = {
    appliedCoupons: [],
    suppressEmail: false,
    profile_uid: profileData ? profileData.profile_uid : UserClass.profile_uid
  };

  function checkResponseStatus(response) {
    const statusOk = ['200', '202', 200, 202];
    const { statusCode, status } = response;

    if ((statusCode || status) && !statusOk.includes(statusCode) && !statusOk.includes(status)) {
      throw new Error('Failed to process');
    }
  }

  function activate() {
    try {
      // Close enough styling for our Stripe card element.
      const style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '14px',
          fontFamily: '"open sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
          color: 'rgb(103, 106, 108)',
          backgroundColor: '#FFFFFF'
        }
      };
      stripe = Stripe(STRIPE_KEY);
      // Create an instance of the Stripe card element.
      elements = stripe.elements();
      listPriceCents = event && event.price ? event.price * 100 : bundle && bundle.price ? bundle.price * 100 : 0;
      card = elements.create('card', { style });
      vm.card = card;
      vm.cardComplete = card._complete;
      card.on('change', event => {
        vm.cardComplete = event.complete;
        $scope.$apply();
      });
      vm.resultsQueried = false;
      vm.profileData = profileData || {}; // set profileData
      vm.adminRegistration = adminRegistration;
      vm.manage = manage;
      vm.loadContent = loadContent;
      vm.admin = UserClass.admin || UserClass.team_leader;
      vm.item = event || bundle; // event or course
      vm.registrationCallback = status => {
        vm.item.status = status;
      };
      vm.chargeAmountCents = listPriceCents; // how much the card will be charged
      vm.discount = null; // discount object
      vm.couponCode = '';

      const locationNames = vm.item.locations ? vm.item.locations.map(({ location }) => location) : [];
      const validLocation =
        vm.item.defaultLocation &&
        (vm.item.defaultLocation === event.delivery_location || locationNames.includes(vm.item.defaultLocation));
      vm.item.selectedLocation = validLocation ? vm.item.defaultLocation : event.delivery_location;

      if (vm.item.passes && vm.item.passes.length) {
        vm.item.passes.forEach(pass => {
          if (!pass.redemptionLimiters || !pass.redemptionLimiters.length) return;

          pass.redemptionLimitersDict = keyBy(pass.redemptionLimiters, 'type');
        });

        vm.selectedPass = vm.item.passes[0].uuid;
      }

      vm.registerButtonText = 'register';

      if (vm.item.passes && vm.item.passes.length) {
        vm.passesAccordionOpen = true;
        vm.cardAccordionOpen = false;
      } else if (vm.chargeAmountCents > 0) {
        vm.cardAccordionOpen = true;
        vm.registerButtonText = 'purchase';
      }
    } catch (e) {
      throw e;
    }
  }

  /**
   * Adds Stripe's card to the form
   */
  vm.loadCard = () => card.mount('#card-element');

  /**
   * Tells stripe to process the form and give us a token.
   * Fills in an error div if something goes wrong.
   */
  const getStripeToken = () => {
    return stripe.createToken(card).then(result => {
      if (result.error) {
        const errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;

        Swal.toast(result.error.message, 'error');
      }

      return result;
    });
  };

  /**
   * Adds a coupon code to the coupon array and calls to submit them to the server
   */
  vm.addCoupon = couponCode => {
    userRegBasePayload.appliedCoupons.push(couponCode);
    applyCoupons();
  };

  /**
   * Submits the coupon information to the server and updates the page with the result
   */
  function applyCoupons() {
    vm.couponApplying = true;

    const itemIdTypeGet = event.event_id ? ApiClass.eventsIdTypeGet : ApiClass.coursesIdTypeGet;

    itemIdTypeGet({ id: event.event_id || event.course_id, type: 'coupons' }, null, {
      queryParams: { couponCodes: userRegBasePayload.appliedCoupons }
    })
      .then(({ data: { coupon_codes_applied, price_after_coupon_cents, coupon_codes_applied_descriptions } }) => {
        vm.couponCode = '';
        vm.couponApplying = false;

        if (coupon_codes_applied && coupon_codes_applied[0]) {
          vm.discount = {
            price: price_after_coupon_cents,
            desc: coupon_codes_applied_descriptions[0]
          };

          vm.chargeAmountCents = vm.discount.price;
          vm.invalidCoupon = false;
        } else {
          vm.invalidCoupon = true;
        }
      })
      .catch(error => {
        vm.couponApplying = false;
        $log.error(error);
      });
  }

  /**
   * Configures the modal based on the method selected registration.
   *
   * @param {*} type
   */
  vm.accordionSelected = type => {
    if (type === 'passes') {
      vm.registerButtonText = 'register';
    }

    if (type === 'card') {
      vm.registerButtonText = 'purchase';
      vm.selectedPass = undefined;
    }
  };

  /**
   * Returns true if the registration information appears sufficient to submit to the server
   */
  vm.readyToSubmit = () => {
    const profileValid = vm.profileInfo && !vm.profileInfo.$invalid && !vm.profileInfo.$dirty;
    const creditCardComplete = vm.chargeAmountCents > 0 ? vm.cardComplete : true && event.status !== 'bundlePurchase';
    const bundleComplete = vm.selectedPass;

    return profileValid && (creditCardComplete || bundleComplete) && !vm.registerBtnLoading;
  };

  /**
   * Function for the payment button. Gets a payment token, if necessary,
   * and then calls register with the token
   */
  vm.submitRegistration = isManage => {
    vm.registerBtnLoading = true;

    if (!vm.selectedPass && vm.chargeAmountCents > 0) {
      getStripeToken().then(result => {
        if (!result.error) {
          postRegToServer(result.token, isManage);
        }
      });
    } else {
      postRegToServer(undefined, isManage);
    }
  };

  /**
   * Posts registration information to the server
   *
   * @param {*} token
   */
  function postRegToServer(token, isManage) {
    if (bundle) {
      return putPass(bundle, token);
    }

    if (event.event_id && vm.adminRegistration) {
      return adminEventRegistration(token);
    }

    if (event.event_id) {
      return userEventRegistration(token, isManage);
    }

    return userCourseRegistration(token, isManage);
  }

  /**
   * Kills the modal
   */
  vm.cancel = () => $uibModalInstance.dismiss('cancel');

  /**
   * Executes an admin event registration
   */
  function adminEventRegistration(token) {
    const adminRegPayload = {
      users: [vm.profileData],
      location: vm.item.selectedLocation,
      suppressEmail: false
    };

    return ApiClass.eventsIdTypePut(
      { id: event.event_id, type: 'attendees' },
      { ...adminRegPayload, stripeToken: token ? token.id : null },
      {
        queryParams: {
          team: true
        }
      }
    )
      .then(({ data: { rejected }, statusCode }) => {
        if (statusCode === 500) {
          throw new Error('Failed to process');
        }

        if (rejected.length) {
          if (rejected[0].status === 'already registered') {
            return $uibModalInstance.close('userAlreadyRegistered');
          }

          return $uibModalInstance.close('userNotRegistered');
        }

        $state.go('app.events.event', { id: event.event_id });

        $uibModalInstance.close('userRegistered');
      })
      .catch(error => {
        $log.error(error);
      });
  }

  /**
   * Executes a course registration for a user
   */
  function userCourseRegistration(token, isManage) {
    let courseRegistrationPromise;

    if (vm.selectedPass) {
      courseRegistrationPromise = ApiClass.coursesIdTypePut(
        { id: event.course_id, type: 'redemptions' },
        { ...userRegBasePayload, id: event.course_id, passId: vm.selectedPass },
        { queryParams: { manage: isManage } }
      );
    } else {
      courseRegistrationPromise = ApiClass.coursesIdTypePut(
        { id: event.course_id, type: 'progress' },
        { ...userRegBasePayload, stripeToken: token ? token.id : null },
        { queryParams: { manage: isManage } }
      );
    }

    return courseRegistrationPromise
      .then(response => {
        checkResponseStatus(response);

        $uibModalInstance.close('userRegistered');
      })
      .catch(error => {
        $log.error(error);

        if (error.data && error.data.description) {
          if (error.data.description === 'User already registered') {
            return $uibModalInstance.close('userAlreadyRegistered');
          }

          if (error.data.description === 'Pass redemption failed') {
            return $uibModalInstance.close('passRedemptionFailure');
          }
        }

        return $uibModalInstance.close('userNotRegistered');
      });
  }

  /**
   * Executes an event registration for a user
   */
  function userEventRegistration(token, isManage) {
    let eventRegistrationPromise;

    if (vm.selectedPass) {
      eventRegistrationPromise = ApiClass.eventsIdTypePut(
        { id: event.event_id, type: 'redemptions', manage },
        { ...userRegBasePayload, id: event.event_id, location: vm.item.selectedLocation, passId: vm.selectedPass },
        { queryParams: { manage: isManage } }
      );
    } else {
      eventRegistrationPromise = ApiClass.eventsIdTypePut(
        { id: event.event_id, type: 'attendees' },
        {
          ...userRegBasePayload,
          course_id: event.course_id,
          stripeToken: token ? token.id : null,
          location: vm.item.selectedLocation
        },
        { queryParams: { manage: isManage } }
      );
    }

    return eventRegistrationPromise
      .then(response => {
        checkResponseStatus(response);

        $uibModalInstance.close('userRegistered');
      })
      .catch(error => {
        $log.error(error);

        if (error.data && error.data.description && error.data.description === 'Pass redemption failed') {
          return $uibModalInstance.close('passRedemptionFailure');
        }

        return $uibModalInstance.close('userNotRegistered');
      });
  }

  function putPass({ uuid }, token) {
    return ApiClass.productsIdTypePut({ type: 'passes', id: uuid }, { stripeToken: token ? token.id : null }, {})
      .then(response => {
        checkResponseStatus(response);
        $uibModalInstance.close('registered');
      })
      .catch(error => {
        $log.error(error);
        return $uibModalInstance.close('userNotRegistered');
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/marketplaceRegister/controller.js